import React from 'react';
import { TrackerChangelogEntry, TrackerSyncMeta } from '../../types';
import { fmtLong, host } from './helpers';

const CHANGE_TYPE_LABEL: Record<string, string> = {
  new: 'New', outcome: 'Outcome', date_change: 'Date changed', delay: 'Delayed',
  correction: 'Corrected', suggestion_verified: 'Verified', suggestion_rejected: 'Rejected',
  removed: 'Removed', registry: 'Registry', new_company: 'New company',
};

interface Props {
  entries: TrackerChangelogEntry[];
  sync?: TrackerSyncMeta | null;
  onOpenCatalyst?: (id: string) => void;
}

/** The `.logrow` feed from tracker.js's renderLog() — rendered inside the "Update log" dialog. The policy
 * banner (and its "Last run" suffix, once a backend writer for meta/sync exists) is unconditional in the
 * original, shown whether or not there's any log data yet — it was wrongly hidden behind `entries.length`
 * here before. */
const ChangelogView: React.FC<Props> = ({ entries, sync, onOpenCatalyst }) => (
  <>
    <p className="policy">
      A scheduled run checks the calendar every weekday morning. It changes a catalyst only when a primary
      source confirms it (company release, SEC filing, FDA, ClinicalTrials.gov or a congress abstract), and
      every change is listed here with that source.
      {sync?.lastRun && ` Last run ${fmtLong(sync.lastRun.slice(0, 10))}${sync.companiesChecked ? `, ${sync.companiesChecked} companies checked` : ''}.`}
    </p>
    {!entries.length ? (
      <div className="empty" style={{ margin: 0 }}><b>No automatic changes yet</b>Changes from the weekday run appear here.</div>
    ) : (
      entries.map((e) => (
        <div className="logrow" key={e.id}>
          <span className="when2">{fmtLong(e.at)}</span>
          <div>
            <div><span className="ct">{CHANGE_TYPE_LABEL[e.change_type || ''] || e.change_type || 'Change'}</span><b>{e.company}</b>{e.asset ? ` · ${e.asset}` : ''}</div>
            <div>{e.summary}</div>
            {(e.before || e.after) && (
              <div className="ba">
                {e.before && <>Was: {e.before}</>}
                {e.before && e.after && ' → '}
                {e.after && <>Now: {e.after}</>}
              </div>
            )}
            {e.source && <a href={e.source} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12.5 }}>{host(e.source)}</a>}
            {e.catalyst_id && onOpenCatalyst && (
              <button type="button" className="linkish" style={{ fontSize: 12.5, marginLeft: 8 }} onClick={() => onOpenCatalyst(e.catalyst_id!)}>Open</button>
            )}
          </div>
        </div>
      ))
    )}
  </>
);

export default ChangelogView;
